/** 主页特别版页脚组件 */
<template src="./index.html" lang="html"></template>
<script>
import main from "./index.js";
export default main;
</script>
<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";
$floor-lg: $home-lg;
$floor-md: $home-md;
$floor-sm: $home-sm;
@import "./index.scss";
</style>
